



























































































































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import States from "@/helpers/states";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "TenantInfo"
})
export default class TenantInfo extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handleTenantFirstName") public handleTenantFirstName!: (payload: string) => void;
  @tppClaims.Action("handleTenantLastName") public handleTenantLastName!: (payload: string) => void;
  @tppClaims.Action("handleTenantEmailAddress") public handleTenantEmailAddress!: (payload: string) => void;
  @tppClaims.Action("handleTenantPhone") public handleTenantPhone!: (payload: string) => void;
  @tppClaims.Action("handleTenantHomeAddress") public handleTenantHomeAddress!: (payload: string) => void;
  @tppClaims.Action("handleTenantAddressTwo") public handleTenantAddressTwo!: (payload: string) => void;
  @tppClaims.Action("handleTenantCity") public handleTenantCity!: (payload: string) => void;
  @tppClaims.Action("handleTenantState") public handleTenantState!: (payload: string) => void;
  @tppClaims.Action("handleTenantZipCode") public handleTenantZipCode!: (payload: string) => void;
  @tppClaims.Action("handleTenantCounty") public handleTenantCounty!: (payload: string) => void;

  // ===== Data ===== //
  public states = States;

  // ===== Methods ===== //

  // ===== Computed ===== //
  get selectedTPPClaim() {
    return this.tppClaims.selectedTPPClaim;
  }

  get tenantFirstName() {
    return this.selectedTPPClaim!.reporter_first_name;
  }
  set tenantFirstName(newVal: string) {
    this.handleTenantFirstName(newVal);
  }

  get tenantLastName() {
    return this.selectedTPPClaim!.reporter_last_name;
  }
  set tenantLastName(newVal: string) {
    this.handleTenantLastName(newVal);
  }

  get tenantEmail() {
    return this.selectedTPPClaim!.owner_email;
  }
  set tenantEmail(newVal: string) {
    this.handleTenantEmailAddress(newVal);
  }

  get tenantPhone() {
    return this.selectedTPPClaim!.reporter_phone;
  }
  set tenantPhone(newVal: string) {
    this.handleTenantPhone(newVal);
  }

  get tenantHomeAddress() {
    return this.selectedTPPClaim!.owner_address_1;
  }
  set tenantHomeAddress(newVal: string) {
    this.handleTenantHomeAddress(newVal);
  }

  get tenantAddressTwo() {
    return this.selectedTPPClaim!.owner_address_2;
  }
  set tenantAddressTwo(newVal: string) {
    this.handleTenantAddressTwo(newVal);
  }

  get tenantCity() {
    return this.selectedTPPClaim!.owner_city;
  }
  set tenantCity(newVal: string) {
    this.handleTenantCity(newVal);
  }

  get tenantState() {
    return this.selectedTPPClaim!.owner_state;
  }
  set tenantState(newVal: string) {
    this.handleTenantState(newVal);
  }

  get tenantZipCode() {
    return this.selectedTPPClaim!.owner_zip_code;
  }
  set tenantZipCode(newVal: string) {
    this.handleTenantZipCode(newVal);
  }

  get tenantCounty() {
    return this.selectedTPPClaim!.owner_county;
  }
  set tenantCounty(newVal: string) {
    this.handleTenantCounty(newVal);
  }
  // ===== Lifecycle ===== //
}
